import { c as _c } from "react/compiler-runtime";
import { looksLikeHtml, sanitizeHtml } from "@/lib/sanitize-html";
import { cn } from "@/lib/utils";
export type RichTextProps = {
  value: string;
  /**
   * `auto` — render HTML when tags are present, otherwise plain text.
   * `html` — always sanitize and render as HTML.
   */
  mode?: "auto" | "html";
  className?: string;
  plainClassName?: string;
};

/**
 * Renders sanitized rich text, or plain text when `mode` is `auto` and
 * the value has no HTML tags.
 */
export function RichText(t0) {
  const $ = _c(14);
  const {
    value,
    mode: t1,
    className,
    plainClassName
  } = t0;
  const mode = t1 === undefined ? "auto" : t1;
  const asHtml = mode === "html" || looksLikeHtml(value);
  if (asHtml) {
    let t2;
    if ($[0] !== className) {
      t2 = cn(className);
      $[0] = className;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== value) {
      t3 = sanitizeHtml(value);
      $[2] = value;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== t3) {
      t4 = {
        __html: t3
      };
      $[4] = t3;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== t2 || $[7] !== t4) {
      t5 = <div className={t2} dangerouslySetInnerHTML={t4} />;
      $[6] = t2;
      $[7] = t4;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    return t5;
  }
  let t2;
  if ($[9] !== plainClassName) {
    t2 = cn(plainClassName);
    $[9] = plainClassName;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== t2 || $[12] !== value) {
    t3 = <p className={t2}>{value}</p>;
    $[11] = t2;
    $[12] = value;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}